import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type Props = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string;
};

export function PageHeader({ title, subtitle, actions, breadcrumb, className }: Props) {
  return (
    <div className={cn("mb-4 sm:mb-6", className)}>
      {breadcrumb && (
        <div className="text-xs text-muted-foreground mb-2 truncate">{breadcrumb}</div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 sm:flex-wrap">
        <div className="min-w-0">
          <h1 className="font-serif text-xl sm:text-2xl lg:text-3xl italic leading-tight text-foreground break-words">
            {title}
          </h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap sm:shrink-0">{actions}</div>}
      </div>
      <div className="hair mt-4 sm:mt-5" />
    </div>
  );
}
